<div *ngIf="header" [innerHTML]="header | safeHtml: 'html'"></div>
<lib-log class="logs" [logs$]="logs$" [scrollToBottom]="scrollToBottom"></lib-log>
